module.exports = __webpack_public_path__ + "img/mobile_check.5db9ce92.png";